import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";
import "./Navbar.css";
import logo from "../assets/logo.png"
export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  // Scroll to a section
  const handleScroll = (section) => {
    if (location.pathname !== "/") {
      navigate("/", { replace: false });
      setTimeout(() => {
        scroller.scrollTo(section, { smooth: true, offset: -70, duration: 500 });
      }, 100);
    } else {
      scroller.scrollTo(section, { smooth: true, offset: -70, duration: 500 });
    }
    setMenuOpen(false); // close menu after clicking
  };

  const handleLogoClick = (e) => {
    if (location.pathname === "/") {
      // Prevent default link behavior
      e.preventDefault();
      // Scroll to top manually
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    // Otherwise, Link works normally
  };
  return (
    <nav className="navbar">

<div className="navbar-logo" onClick={handleLogoClick}>
  <Link to="/">
    <img src={logo} style={{ height: "75px", cursor: "pointer" }} />
  </Link>
</div>

      {/* Hamburger icon */}
      <div
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

   <ul className={`navbar-links ${menuOpen ? "open" : ""}`}>
  <li>
    <a onClick={() => handleScroll("home")}>Home</a>
  </li>
  <li>
    <a onClick={() => handleScroll("about")}>About</a>
  </li>
  <li>
    <a onClick={() => handleScroll("tours")}>Tours</a>
  </li>
  <li>
    <a onClick={() => handleScroll("contact")}>Contact</a>
  </li>
</ul>

    </nav>
  );
}
